import React, { forwardRef } from "react";

export * from "lucide-react/dist/esm/lucide-react.js";

export const Tag = forwardRef(function Tag(
  {
    size = 24,
    color = "currentColor",
    strokeWidth = 2,
    absoluteStrokeWidth = false,
    className = "",
    ...props
  },
  ref
) {
  const effectiveStrokeWidth = absoluteStrokeWidth
    ? (Number(strokeWidth) * 24) / Number(size || 24)
    : strokeWidth;

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={effectiveStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={`lucide lucide-tag ${className}`.trim()}
      aria-hidden={props["aria-label"] ? undefined : true}
      {...props}
    >
      <path d="M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z" />
      <circle cx="7.5" cy="7.5" r=".5" fill="currentColor" />
    </svg>
  );
});

Tag.displayName = "Tag";
